<template>
  <section id="success-cases" class="section" data-component="success-cases">
    <div class="container">
      <div class="section-header cases-header reveal">
        <span class="card-tag">成功案例</span>
        <h2 class="card-title">与行业领军者共同定义未来</h2>
        <p class="card-description">
          从3A游戏到AI大模型，海曦科技已为多个行业的标杆项目提供算力支撑
        </p>
      </div>
    </div>

    <div class="cases-grid reveal">
      <article
        v-for="item in cases"
        :key="item.title"
        class="case-card"
      >
        <LazyBg :src="item.image" />
        <div class="case-card__body">
          <h3 class="case-card__title">{{ item.title }}</h3>
          <p class="case-card__desc">{{ item.desc }}</p>
        </div>
      </article>
    </div>
  </section>
</template>

<script setup lang="ts">
import LazyBg from '@/components/LazyBg.vue';
import imgAi from '@/assets/cases/ai.jpg';
import imgAviation from '@/assets/cases/aviation.jpg';
import imgLab from '@/assets/cases/lab.jpg';
import imgOcean from '@/assets/cases/ocean.jpg';
import '@/styles/newhome/home/cases.css';

const cases = [
  {
    title: '大规模AI算力集群',
    desc: '60天交付89台服务器集群（行业平均90天），含82台海光液冷高性能计算节点与7套分布式存储系统，GPU利用率稳定85%以上。',
    image: imgAi
  },
  {
    title: '航空仿真计算集群',
    desc: '33台国产海光处理器集群30天极速交付，航空仿真计算效率提升40%以上，单次成本降低35%，保障国产大飞机研发节点。',
    image: imgAviation
  },
  {
    title: '新疆理化所超算集群',
    desc: '29台服务器跨地域远程交付，材料物理模拟周期从2周压缩至5天，效率提升50%。全年可用性99.95%，通过中科院信息化专项验收。',
    image: imgLab
  },
  {
    title: '海洋监测预报计算集群',
    desc: '45天交付高性能计算集群，较行业平均缩短40%。风暴潮预警计算时效从6小时压缩至1.5小时，通过国家海洋局质控验收。',
    image: imgOcean
  }
];
</script>
